import type { TFunction } from 'i18next';
import type { Plandokument } from '@origo/planregister';
import type { DocumentItem } from '../types';
import { dokumenttypeLabel } from '../codelists/dokumenttype';

const norwegianDateFormat = new Intl.DateTimeFormat('nb-NO', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
});

export function toDocumentItem(doc: Plandokument, t: TFunction): DocumentItem {
    return {
        id: doc.dokumentId,
        dokumentnavn: doc.tittel,
        dokumenttype: dokumenttypeLabel(doc.dokumenttype, t),
        dato: doc.dokumentdato ? norwegianDateFormat.format(doc.dokumentdato) : undefined,
        url: doc.referansedokumentfil,
    };
}
